<div #reviewField
     *ngIf="visible && options?.displayType !== 'PublicRecord'">
    <ng-container *ngIf="!isEditing">
        <cv-schema-render-form-display [fieldOptions]="options"
                                       [field]="field"
                                       [value]="value"
                                       [historical]="historical"
                                       [show]="show"
                                       [active]="active"
                                       (openHistorical)="showHistorical($event)">
        </cv-schema-render-form-display>
    </ng-container>

    <ng-container *ngIf="isEditing">
        <cv-schema-render-form-input [fieldOptions]="options"
                                     [control]="formControl"
                                     [field]="field"
                                     [historical]="historical"
                                     [show]="show"
                                     [active]="active"
                                     [indexTab]="indexTab"
                                     (openHistorical)="showHistorical($event)">
        </cv-schema-render-form-input>
    </ng-container>
</div>

<ng-container *ngIf="options?.displayType === 'PublicRecord'">
    <cv-schema-render-form-custom [field]="field"
                                  [fieldOptions]="options"
                                  [control]="formControl">
    </cv-schema-render-form-custom>
</ng-container>